import React from "react";
import {
  Avatar,
  Box,
  Grid,
  Paper,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  VM_Colors,
} from "../../Styles/VMStyles";
import CallIcon from "@mui/icons-material/Call";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { returnDate } from "../../Util/UtilHelper";
import FormFieldValues from "../../Components/Custom/FormFieldValues";

// 📦 Helper to format Enquiry Info for Mail & Chat
const getEnquiryInfoText = (customer) => {
  if (!customer) return '';

  const eventDates = Array.isArray(customer.appointment_date)
    ? customer.appointment_date.map(returnDate).join(', ')
    : returnDate(customer.appointment_date);

  return `Enquiry Details:
Enquiry ID: ${customer.appointment_id}
Name: ${customer.name}
Phone: ${customer.country_code}${customer.phone_no}
Event Date(s): ${eventDates}`;
};

function VMEDBasicInfo({ customer, showContactActions = true }) {
  if (!customer) return null;

  const enquiryText = encodeURIComponent(getEnquiryInfoText(customer));
  const emailBody = encodeURIComponent(getEnquiryInfoText(customer));
  const mailToLink = `mailto:${customer.email}?subject=Enquiry%20Details&body=${emailBody}`;
  const callLink = `tel:${customer.country_code}${customer.phone_no}`;
  const whatsappLink = `https://wa.me/${customer.country_code.replace('+', '')}${customer.phone_no}?text=${enquiryText}`;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: {
          xs: "column",
          md: "row",
        },
        p: 1,
        gap: 2,
      }}
    >
      {/* Left Panel - Enquiry Info */}
      <Paper sx={{ backgroundColor: VM_Colors.white1, padding: 2, width: showContactActions ? { xs: '100%', md: '60%' } : '100%' }}>
        <Grid container spacing={5} 
         alignItems="center"
          justifyContent="space-between"
          rowSpacing={3}
      >
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <FormFieldValues title="Enquiry ID" subtitle={customer.appointment_id} textColor={VM_Colors.primary}/>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <FormFieldValues title="Name" subtitle={customer.name} textColor={VM_Colors.primary} />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <FormFieldValues
              title="Event Date"
              subtitle={Array.isArray(customer.appointment_date)
                ? customer.appointment_date.map(dateStr => returnDate(dateStr)).join(', ')
                : returnDate(customer.appointment_date)}
              textColor={VM_Colors.primary}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <FormFieldValues
              title="Created By"
              subtitle={customer?.created_by?.name || 'N/A'}
              textColor={VM_Colors.primary}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <FormFieldValues
              title="Lead Source"
              subtitle={customer.lead || 'N/A'}
              textColor={VM_Colors.primary}
            />
          </Grid>
          </Grid>  
      </Paper>

      {showContactActions ? (
      /* Right Panel - Contact Actions */
      <Paper
        sx={{
          borderRadius: "10px",
          pl: 2,pr:2,
          backgroundColor: VM_Colors.white,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          width: { xs: "100%", md: "40%" },
          boxSizing: "border-box",
        }}
      >
        <Box>
          <Typography variant="subtitle2" color={VM_Colors.steel_gray}>
            Customer Phone
          </Typography>
          <Typography pt={0.5}  sx={{ color: VM_Colors.primary,fontSize:'16px' }}>
            {customer.country_code + customer.phone_no}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mt: { xs: 2, md: 0 },
          }}
        >
          {/* 📧 Mail */}
          <Tooltip title="Send Email">
            <IconButton
              component="a"
              href={mailToLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Avatar sx={{ bgcolor: VM_Colors.lead }}>
                <MailOutlineIcon />
              </Avatar>
            </IconButton>
          </Tooltip>

          {/* 📞 Call */}
          <Tooltip title="Call Customer">
            <IconButton
              component="a"
              href={callLink}
            >
              <Avatar sx={{ bgcolor: VM_Colors.lead }}>
                <CallIcon />
              </Avatar>
            </IconButton>
          </Tooltip>

          {/* 💬 Chat */}
          <Tooltip title="Chat on WhatsApp">
            <IconButton
              component="a"
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Avatar sx={{ bgcolor: VM_Colors.lead }}>
                <WhatsAppIcon />
              </Avatar>
            </IconButton>
          </Tooltip>
        </Box>
      </Paper>
      ) : null}
    </Box>
  );
}

export default VMEDBasicInfo;
